import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { tokenSmsApi as API } from '../Apis';

export const GenerateTokenSmsDocs: IDocs = {
  title: 'GenerateTokenSms',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.generateTokenSms',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.post({
    phoneNumber: stateRequestParameters.phoneNumber,
  });

export const GenerateTokenSmsMachine = GenericMachine(prepareCall, {
  docs: GenerateTokenSmsDocs,
  definitions: API.definitions,
});
